/* import __COLOCATED_TEMPLATE__ from './remove-sync-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();